import React from "react";
import classnames from "classnames";
import IconButton from "../../../base/button/icon_button";
import {CrisisAlert, CrisisAlertOutlined} from "@mui/icons-material";
import {Box, Tooltip} from "@mui/material";

const PartFormChipsContent = ({
                                  partForm,
                                  onToggleRequired,
                                  togglingRequired = false,
                                  disabled = false,
                                  buttonProps,
                              }) => {
    const title = partForm?.form?.title ?? "";
    const isRequired = partForm?.isRequired ?? false;

    return (
        <div className={classnames("part-form-chips-content", {required: isRequired})}>
            <Tooltip title={isRequired ? "Required — click to mark optional" : "Optional — click to mark required"} arrow placement="bottom">
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <IconButton
                        size="medium"
                        color={isRequired ? "primary" : "secondary"}
                        className="required-toggle"
                        sx={{
                            padding: '4px',
                            height: 28,
                            width: 28,
                        }}
                        disabled={disabled || togglingRequired}
                        {...buttonProps}
                        onPressed={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onToggleRequired?.(partForm);
                        }}
                    >
                        {
                            isRequired
                                ? <CrisisAlert className="icon large"/>
                                : <CrisisAlertOutlined className="icon large"/>
                        }
                    </IconButton>
                </Box>
            </Tooltip>
            <Tooltip title={title} arrow placement="bottom">
                <p>{title}</p>
            </Tooltip>
        </div>
    );
};

export default PartFormChipsContent;
